/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { css, jsx } from '@emotion/core'

import Icon from '../../ui/Icon/IconFactory'
import { SITE_VARIABLES, mq } from '../../themes/variables'
import { getDefaultTradeStylesObj } from './trade.styles'
import { TeamObject } from '../../types/props'
import { useSiteVars } from '../../themes/useSiteVars'

interface TradeProps {
    teams: TeamObject[] | string
    teamGets: string
    preview?: boolean
}

const Trade: FunctionalComponent<TradeProps> = ({ teams: teamsRaw, teamGets: teamGetsRaw, preview }) => {
    const siteVars = useSiteVars()

    const rootStyles = css`
        display: flex;
        flex-direction: column;
        padding-top: 1rem;
        font-weight: 800;
        margin: 1.5rem 0;
        border-top: 0.25rem solid ${siteVars.COLORS.GRAY};
        ${mq[2]} {
            margin: 2rem 0;
            flex-flow: row wrap;
            justify-content: space-between;
        }
    `

    let teams = teamsRaw
    let teamGets = teamGetsRaw

    if (typeof teamsRaw === 'string') {
        const unescapedTeams = teamsRaw.replace(/\\/g, '')
        teams = JSON.parse(unescapedTeams)
    }

    if (typeof teamGetsRaw === 'string') {
        const unescapedTeamGets = teamGetsRaw.replace(/\\/g, '')
        teamGets = JSON.parse(unescapedTeamGets)
    }

    const getPlayers = (players: string[]) => {
        return players.map((player) => <div key={player}>{player}</div>)
    }

    return (
        <div css={rootStyles}>
            {Array.isArray(teams) &&
                teams.map((team, i, teams) => {
                    const TradeStyles = getDefaultTradeStylesObj(i, teams, siteVars, preview)

                    return (
                        <Fragment>
                            <div css={TradeStyles.contentWrapper}>
                                <div css={TradeStyles.teamWrapper}>
                                    <div css={TradeStyles.teamTopic}>
                                        <img css={TradeStyles.logo} src={team.logoUrl} alt={`${team.name} Logo`} />
                                        <span css={TradeStyles.team}>{team.name}</span>
                                    </div>
                                </div>
                                <div css={TradeStyles.players}>
                                    <span css={TradeStyles.subHead}>Receive</span>
                                    {Array.isArray(teamGets) &&
                                        teamGets.map((player, k) => {
                                            if (i === k) return getPlayers(player)
                                        })}
                                </div>
                            </div>
                            <div css={TradeStyles.iconWrapper}>
                                <Icon icon="Trade" fill="#e7e7e7" iconClass={TradeStyles.icon} />
                            </div>
                        </Fragment>
                    )
                })}
        </div>
    )
}

export default Trade
